import React from "react";
import { useRef } from "react";
import {
  facebookIcon,
  footerLogo,
  instagramIcon,
  newWosamLogo,
  twitterIcon,
  wosamApartmentsLogo,
  WosAmHotelLogo,
  yellowFacebook,
  yellowInstagram,
  yellowTwitter,
  youtubeIcon,
} from "../assets";
import { Link, NavLink } from "react-router-dom";
import { footerLinks } from "../constants";

const Footer = () => {
  const handleScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <div>
      {/* <div className='md:mx-10 mx-4'>
        <div className="flex justify-center">
          <button
            onClick={handleScrollToTop}
            className="py-2 px-12 text-white bg-black rounded-t-md font-bold"
          >
            Back to Top
          </button>
        </div>
        <div className="bg-[#C58E47] md:py-[100px] md:px-[100px] px-4 py-10 pb-10 text-black">
          <div className="flex md:flex-row flex-col md:items-start items-center justify-between pb-16">
            <div className="flex flex-col md:items-start items-center w-[50%]">
              <img src={wosamApartmentsLogo} alt="" className="h-[80px] w-[120px] md:mb-6 mb-4" />
              <p className=" md:w-[70%] md:text-left text-center">
                WosAm luxury apartments, Ikeja GRA, Lagos, Nigeria.
              </p>
            </div>
            <div className="flex md:flex-row flex-col md:items-start justify-end items-center md:gap-8 gap-8 md:text-left text-center">
              <div className="">
                <p className="font-bold  md:mb-6 mb-4">
                  ACCOMODATION
                </p>
                <div className="flex flex-col md:gap-4 gap-2 ">
                  <Link to='/apartments' className=''>
                    Room & Suites
                  </Link>
                </div>
              </div>
              <div className="">
                <p className="font-bold  md:mb-6 mb-4">
                  OTHERS
                </p>
                <div className="flex flex-col md:gap-4 gap-2  cursor-pointer">
                  <Link to='/experience' className=''>
                    About Us
                  </Link>
                  <Link to='/gallery' className=''>
                    Gallery
                  </Link>
                  <Link to='/privacy-policies' className="">
                    Privacy Policies
                  </Link>
                  <Link to='/terms-and-conditions' className="">
                    Terms & Conditions
                  </Link>
                </div>
              </div>
              <div className="">
                <p className="font-bold  md:mb-6 mb-4">
                  OUR PHONE NUMBERS
                </p>
                <div className="flex flex-col md:gap-4 gap-2">
                  <p className="">
                    09164418000, 09164419000, 09153253750
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="border-t-2 border-white pt-16 flex flex-col justify-center items-center">
            <div className="flex justify-center items-center gap-4">
              <img src={instagramIcon} alt="" className="md:h-[60px] h-10" />
              <img src={facebookIcon} alt="" className="md:h-[60px] h-10" />
              <img src={youtubeIcon} alt="" className="md:h-[60px] h-10" />
              <img src={twitterIcon} alt="" className="md:h-[60px] h-10" />
            </div>
            <p className="text-center font-light  mt-4">
              Copyright All right reserved. WosAm Apartments
            </p>
          </div>
        </div>
      </div> */}
      <div className="bg-[#050505]">
        <div className="flex flex-col items-center border-b border-[#919191] py-12">
          <img src={footerLogo} alt="" className="mb-6 h-[60px]" />
          <p className="text-center text-white mb-10 font-barlow font-light md:px-0 px-4">
            Welcome to The Imperial by WosAm Apartments, where comfort meets
            elegance.
          </p>
          <div className="flex md:flex-row flex-col justify-center md:gap-20 gap-10">
            {footerLinks.map((item) => (
              <NavLink
                key={item.id}
                to={item.linkRoute}
                className="hover:text-[#FF9700] md:text-start text-center text-white"
                style={({ isActive }) => {
                  return {
                    color: isActive ? "#FF9700" : "",
                  };
                }}
              >
                {item.linkName}
              </NavLink>
            ))}
          </div>
        </div>
        <div className="flex md:flex-row flex-col md:justify-center px-4 md:gap-32 gap-10 py-12 md:px-[100px]">
          <div className="flex flex-col gap-4">
            <p className="text-white  font-barlow font-light">CALL US</p>
            <p className="text-white  font-barlow font-light">
              09028888883 07074711608 07074711610
            </p>
          </div>
          <div className="flex flex-col gap-4">
            <p className="text-white  font-barlow font-light">ADDRESS</p>
            <p className="text-white  font-barlow font-light">
              34, ODUDUWA WAY, IKEJA GRA, LAGOS STATE
            </p>
            <p className="text-white  font-barlow font-light">
              119 OBAFEMI AWOLOWO ROAD, AGO-IWOYE, OGUN STATE
            </p>
            <p className="text-white  font-barlow font-light">
              BUILDING E3, GORA STREET JASMINE ESTATES, DAWAKI AREA, ABUJA
            </p>
          </div>
          <div className="flex flex-col gap-4">
            <p className="text-white  font-barlow font-light">MAIL US</p>
            <p className="text-white  font-barlow font-light">
              info@wosamapartments.com
            </p>
          </div>
        </div>

        <div className="flex md:flex-row flex-col justify-between items-center bg-[#222222] md:px-[100px] px-4 md:py-4 py-6 md:gap-0 gap-6">
          <div className="flex items-center gap-10">
            <Link
              to="/privacy-policies"
              className="text-white  font-barlow font-light"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms-and-conditions"
              className="text-white  font-barlow font-light"
            >
              Terms & Conditions
            </Link>
          </div>
          <p className="text-white  font-barlow font-light">
            2024 Copyrights Reserved.
          </p>
          <div className="flex item-center justify-end gap-4">
            <a href="https://web.facebook.com/WosamArena/" target="_blank">
              <img src={yellowFacebook} alt="" className="" />
            </a>
            <a href="https://www.instagram.com/wosamarena/" target="_blank">
              <img src={yellowInstagram} alt="" className="" />
            </a>
            <a href="https://www.tiktok.com/@wosamhotels" target="_blank">
              <img src={yellowTwitter} alt="" className="" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
